<div class="relative flex flex-col w-full h-full bg-gray-100 dark:bg-gray-900">
    <!-- Header -->
    <div class="flex flex-row justify-between items-center bg-white dark:bg-gray-800 rounded-t-lg px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <div class="text-xl font-semibold text-gray-900 dark:text-gray-100">{{ this.data?.finance_id ? 'Editar' : 'Adicionar' }} Financeiro</div>
        <button (click)="clear()" mat-icon-button class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <!-- Form Content -->
    <div class="flex-1 bg-white dark:bg-gray-800 p-6 overflow-auto" *ngIf="!loadingData; else loadingTemplate">
        <form [formGroup]="form" class="space-y-6">
            <!-- Informação da Venda (Recebimentos) -->
            <div *ngIf="saleData?.final_value && !isCommission()" class="p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div class="flex items-center justify-between">
                        <span class="text-sm text-gray-600 dark:text-gray-400">Valor Total da Venda:</span>
                        <span class="text-base font-bold text-gray-900 dark:text-gray-100">
                            {{ saleData.final_value | currency : 'BRL' : 'symbol' : '1.2-2' }}
                        </span>
                    </div>
                    <div class="flex items-center justify-between">
                        <span class="text-sm text-gray-600 dark:text-gray-400">Já Lançado:</span>
                        <span class="text-base font-bold text-gray-900 dark:text-gray-100">
                            {{ totalExistingValue | currency : 'BRL' : 'symbol' : '1.2-2' }}
                        </span>
                    </div>
                    <div class="flex items-center justify-between">
                        <span class="text-sm text-gray-600 dark:text-gray-400">Disponível:</span>
                        <span class="text-base font-bold text-green-600 dark:text-green-400">
                            {{ getRemainingValue() | currency : 'BRL' : 'symbol' : '1.2-2' }}
                        </span>
                    </div>
                </div>
            </div>

            <!-- Informação da Comissão -->
            <div *ngIf="saleData?.commission_value && isCommission()" class="p-4 bg-orange-50 dark:bg-orange-900/20 rounded-lg border border-orange-200 dark:border-orange-800">
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div class="flex items-center justify-between">
                        <span class="text-sm text-gray-600 dark:text-gray-400">Valor da Comissão da Venda:</span>
                        <span class="text-base font-bold text-gray-900 dark:text-gray-100">
                            {{ saleData.commission_value | currency : 'BRL' : 'symbol' : '1.2-2' }}
                        </span>
                    </div>
                    <div class="flex items-center justify-between">
                        <span class="text-sm text-gray-600 dark:text-gray-400">Já Lançado:</span>
                        <span class="text-base font-bold text-gray-900 dark:text-gray-100">
                            {{ getTotalExistingCommissions() | currency : 'BRL' : 'symbol' : '1.2-2' }}
                        </span>
                    </div>
                    <div class="flex items-center justify-between">
                        <span class="text-sm text-gray-600 dark:text-gray-400">Disponível:</span>
                        <span class="text-base font-bold text-green-600 dark:text-green-400">
                            {{ getRemainingCommissionValue() | currency : 'BRL' : 'symbol' : '1.2-2' }}
                        </span>
                    </div>
                </div>
            </div>

            <!-- Seção Previsão -->
            <div>
                <h3 class="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4">Previsão</h3>
                <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <!-- Data Prevista -->
                    <div>
                        <mat-form-field class="w-full">
                            <mat-label>Data Prevista</mat-label>
                            <input readonly [formControlName]="'date'" [matDatepicker]="picker_date" (click)="picker_date.open()" matInput />
                            <mat-datepicker-toggle matSuffix [for]="picker_date"></mat-datepicker-toggle>
                            <mat-datepicker #picker_date></mat-datepicker>
                            <mat-error>Campo Obrigatório</mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Valor / Valor Previsto -->
                    <div>
                        <mat-form-field class="w-full">
                            <mat-label>{{ isOutrosModule ? 'Valor Previsto' : 'Valor' }}</mat-label>
                            <input
                                type="text"
                                [formControlName]="'value'"
                                matInput
                                mask="separator.2"
                                [thousandSeparator]="'.'"
                                [decimalMarker]="','"
                                [allowNegativeNumbers]="false"
                                placeholder="0,00"
                            />
                            <span matTextPrefix>R$</span>
                            <mat-error>Campo Obrigatório</mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Valor Negociado (somente Outros) -->
                    <div *ngIf="isOutrosModule">
                        <mat-form-field class="w-full">
                            <mat-label>Valor Negociado</mat-label>
                            <input
                                type="text"
                                [formControlName]="'negotiated_value'"
                                matInput
                                mask="separator.2"
                                [thousandSeparator]="'.'"
                                [decimalMarker]="','"
                                [allowNegativeNumbers]="false"
                                placeholder="0,00"
                            />
                            <span matTextPrefix>R$</span>
                        </mat-form-field>
                    </div>

                    <!-- Número do Documento (somente Outros) -->
                    <div *ngIf="isOutrosModule">
                        <mat-form-field class="w-full">
                            <mat-label>Número do Documento</mat-label>
                            <input type="text" [formControlName]="'document_number'" matInput placeholder="Ex.: NF 12345" />
                            <mat-error>Campo Obrigatório</mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Tipo Previsto -->
                    <div>
                        <mat-form-field class="w-full">
                            <mat-label>Tipo Previsto</mat-label>
                            <mat-select [formControlName]="'forecast_payment_type'">
                                <mat-option *ngFor="let type of paymentTypeOptions" [value]="type.value">
                                    {{ type.label }}
                                </mat-option>
                            </mat-select>
                            <mat-error>Campo Obrigatório</mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Parcela -->
                    <div>
                        <mat-form-field class="w-full">
                            <mat-label>Parcela</mat-label>
                            <input type="number" [formControlName]="'installment'" matInput min="1" placeholder="1" />
                            <mat-error>Campo Obrigatório</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- Seção Conta Financeira -->
            <div>
                <h3 class="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4">Conta Financeira</h3>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <mat-form-field class="w-full">
                            <mat-label>Conta Financeira</mat-label>
                            <mat-select [formControlName]="'financial_account_id'">
                                <mat-option [value]="null">-- Nenhuma --</mat-option>
                                <ng-container *ngFor="let operation of getOperationKeys()">
                                    <mat-optgroup [label]="getOperationLabel(operation)">
                                        <ng-container *ngFor="let group of getGroupKeys(operation)">
                                            <mat-option *ngFor="let account of getAccountsByOperationAndGroup(operation, group)" [value]="account.financial_account_id">
                                                <span class="font-medium">{{ group }}</span> - {{ account.title }}
                                            </mat-option>
                                        </ng-container>
                                    </mat-optgroup>
                                </ng-container>
                            </mat-select>
                            <mat-error *ngIf="form.get('financial_account_id')?.hasError('required')">Campo Obrigatório</mat-error>
                        </mat-form-field>
                    </div>

                    <div *ngIf="showEmployeeReceiverField()">
                        <mat-form-field class="w-full">
                            <mat-label>Funcionário</mat-label>
                            <mat-select formControlName="user_receiver_id" panelClass="employee-select-panel">
                                <mat-option disabled class="search-option">
                                    <span class="search-input-container" (click)="$event.stopPropagation()">
                                        <input
                                            [formControl]="employeeSearchControl"
                                            placeholder="Buscar funcionário..."
                                            (click)="$event.stopPropagation()"
                                            (keydown)="$event.stopPropagation()"
                                            (keyup)="$event.stopPropagation()"
                                            class="w-full px-2 py-1 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-sm"
                                            autocomplete="off"
                                        />
                                    </span>
                                </mat-option>
                                <mat-divider></mat-divider>
                                <mat-option [value]="null">-- Nenhum --</mat-option>
                                <mat-option *ngFor="let emp of filteredEmployeeOptions" [value]="emp.user_id">
                                    {{ emp.name }}
                                </mat-option>
                                <mat-option *ngIf="filteredEmployeeOptions.length === 0" [value]="null" disabled>
                                    Nenhum funcionário encontrado
                                </mat-option>
                            </mat-select>
                            <mat-icon matSuffix [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
                            <mat-error *ngIf="form.get('user_receiver_id')?.hasError('required')">Campo Obrigatório</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- Seção Detalhes do Pagamento -->
            <div>
                <h3 class="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4">Detalhes do Pagamento</h3>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <!-- Data do Pagamento -->
                    <div>
                        <mat-form-field class="w-full">
                            <mat-label>Data do Pagamento</mat-label>
                            <input readonly [formControlName]="'date_payed'" [matDatepicker]="picker_date_payed" (click)="picker_date_payed.open()" matInput />
                            <button
                                *ngIf="form.get('date_payed')?.value"
                                mat-icon-button
                                matSuffix
                                (click)="form.get('date_payed')?.setValue(null); $event.stopPropagation()"
                                type="button"
                                class="mr-1"
                            >
                                <mat-icon class="icon-size-5">clear</mat-icon>
                            </button>
                            <mat-datepicker-toggle matSuffix [for]="picker_date_payed"></mat-datepicker-toggle>
                            <mat-datepicker #picker_date_payed></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <!-- Tipo Realizado -->
                    <div>
                        <mat-form-field class="w-full">
                            <mat-label>Tipo Realizado</mat-label>
                            <mat-select [formControlName]="'realized_payment_type'">
                                <mat-option [value]="null">-- Nenhum --</mat-option>
                                <mat-option *ngFor="let type of paymentTypeOptions" [value]="type.value">
                                    {{ type.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Observações -->
                <div class="mt-4">
                    <mat-form-field class="w-full">
                        <mat-label>Observações</mat-label>
                        <textarea
                            [formControlName]="'description'"
                            matInput
                            rows="3"
                            placeholder="Adicione observações sobre o lançamento financeiro..."
                        ></textarea>
                    </mat-form-field>
                </div>
            </div>

            <!-- Seção Anexos -->
            <div>
                <h3 class="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4">Anexos</h3>
                <div class="space-y-4">
                    <div class="flex items-center justify-center gap-3">
                        <button 
                            mat-stroked-button 
                            color="primary" 
                            (click)="fileInput.click()" 
                            [disabled]="!canUploadFilesOnFinance()"
                            class="h-14 flex items-center"
                        >
                            <mat-icon [svgIcon]="'heroicons_outline:arrow-up-tray'"></mat-icon>
                            Selecionar Arquivo
                        </button>
                        <input 
                            #fileInput 
                            type="file" 
                            name="fileInput"
                            multiple 
                            class="hidden" 
                            [disabled]="!canUploadFilesOnFinance()"
                            (change)="onSelectFiles($event)" 
                        />
                        <button 
                            *ngIf="pendingAttachments.length > 0 || attachmentsToDelete.length > 0"
                            mat-flat-button 
                            color="primary" 
                            (click)="saveAttachments()"
                            [disabled]="loading"
                            class="h-14 flex items-center"
                        >
                            <mat-icon [svgIcon]="'heroicons_outline:check'"></mat-icon>
                            Salvar Anexos
                        </button>
                    </div>

                    <!-- No attachments message -->
                    <div *ngIf="attachments.length === 0 && pendingAttachments.length === 0" class="text-center py-12">
                        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">Nenhum anexo</h3>
                        <p class="text-gray-500 dark:text-gray-400">Adicione arquivos usando o botão acima</p>
                    </div>

                    <!-- Attachments list -->
                    <div class="space-y-2">
                        <div
                            *ngFor="let file of attachments"
                            class="flex items-center justify-between p-3 rounded border border-gray-200 dark:border-gray-700 bg-white dark:bg-transparent"
                            [class.cursor-pointer]="isImage(file) || isPdf(file)"
                            [class.hover:opacity-90]="isImage(file) || isPdf(file)"
                            (click)="onFileClick(file, $event)"
                        >
                            <div class="flex items-center gap-3 min-w-0 flex-1">
                                <mat-icon [svgIcon]="getFileIcon(file)" class="text-gray-500"></mat-icon>
                                <div class="min-w-0 flex-1">
                                    <div class="font-medium truncate">{{ getFileDisplayName(file) }}</div>
                                    <div class="text-xs text-gray-500 truncate">{{ file.createdAt | date : 'dd/MM/yy HH:mm' }}</div>
                                </div>
                            </div>
                            <div class="flex items-center gap-1" (click)="$event.stopPropagation()">
                                <button mat-icon-button (click)="download(file)" title="Baixar">
                                    <mat-icon [svgIcon]="'heroicons_outline:arrow-down-tray'"></mat-icon>
                                </button>
                                <button mat-icon-button color="warn" (click)="remove(file)" [matTooltip]="'Remover'">
                                    <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                </button>
                            </div>
                        </div>
                        <div
                            *ngFor="let item of pendingAttachments; let i = index"
                            class="flex items-center justify-between p-3 rounded border border-dashed border-gray-300 bg-gray-50"
                        >
                            <div class="flex items-center gap-3 min-w-0">
                                <mat-icon [svgIcon]="'heroicons_outline:clock'" class="text-amber-600"></mat-icon>
                                <div class="min-w-0">
                                    <div class="font-medium truncate">{{ item?.file?.name || 'Arquivo sem nome' }}</div>
                                    <div class="text-xs text-amber-700">Não enviado</div>
                                </div>
                            </div>
                            <div class="flex items-center gap-1">
                                <button mat-icon-button color="warn" (click)="removePending(i)" [matTooltip]="'Remover'">
                                    <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <!-- Loading Template -->
    <ng-template #loadingTemplate>
        <div class="flex-1 flex items-center justify-center bg-white dark:bg-gray-800">
            <mat-spinner></mat-spinner>
        </div>
    </ng-template>

    <!-- Footer -->
    <ng-container *ngIf="!loadingData">
        <div class="flex items-center justify-between px-6 py-4 bg-white dark:bg-gray-800 rounded-b-lg border-t border-gray-200 dark:border-gray-700">
            <div>
                <button (click)="deleteFinance()" *ngIf="data?.finance_id && !disableDelete && loggedUser?.canDeleteRecords" mat-stroked-button [color]="'warn'" class="flex items-center gap-2">
                    <mat-icon [svgIcon]="'heroicons_outline:trash'" class="w-4 h-4"></mat-icon>
                    Apagar
                </button>
            </div>
            <div class="flex items-center gap-3">
                <button (click)="clear()" mat-stroked-button [color]="'primary'" [matDialogClose]="'cancelled'">Fechar</button>
                <button (click)="done()" [disabled]="loading || !canEditFinance()" [color]="'primary'" mat-flat-button class="flex items-center gap-2">
                    <mat-icon [svgIcon]="'heroicons_outline:check'" class="w-4 h-4" *ngIf="!loading"></mat-icon>
                    <mat-spinner diameter="16" *ngIf="loading"></mat-spinner>
                    Salvar
                </button>
            </div>
        </div>
    </ng-container>
</div>
